import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { partnersService } from "../services/partner.service";
import { IStringOption } from "Dashboard/domain/IStringOption";

const PartnerSelectForSearch = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IStringOption[]>([]);
  const [value, setValue] = useState<IStringOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const response = await partnersService.getPartnersForDropdown();
      const op = response.partners.map((partner) => {
        return {
          label: partner.shortName,
          value: partner.shortName,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  const addOption = (search: string): IStringOption => {
    try {
      const newOption: IStringOption = {
        label: search,
        value: search,
      };
      setOptions([...options, newOption]);
      return newOption;
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = (inputValue: any) => {
    try {
      const newOption = addOption(inputValue);
      handleChange(newOption, null);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p>{inputValue}</p>;
  };

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else if (props.value) {
      const newOption = addOption(props.value);
      setValue(newOption);
    }
  }, [options, props.value]);

  return (
    <CreatableSelect
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      isClearable
      placeholder=""
      formatCreateLabel={formatCreate}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      options={options}
      value={value}
      {...{ error: props.error }}
    />
  );
});

export default PartnerSelectForSearch;
